import { BarberEmployee, Slot } from "../../Model";
import { BarberRepository } from "../../Repository";

export async function barberEmployeeSelected(
  barber: string,
  repository: BarberRepository
): Promise<Slot[]> {
  return repository.setSelectedBarberEmployee(barber);
}
